export default {
    city: 'City',
    cityPlaceHolder: 'Select a city',
    noCity: 'City not found',
    noCities: 'Cities not found',
};
